import { Button, ButtonProps } from '@chakra-ui/react';

import { Replace } from '$utils/replace';

interface SelectButtonProps extends Replace<ButtonProps, { value: string }> {
  actualValue: string;
}

export function SelectButton({
  actualValue,
  value,
  children,
  onClick,
  ...props
}: SelectButtonProps) {
  const active = actualValue === value;

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      h="32px"
      px="14px"
      fontFamily="mono"
      fontSize="11px"
      letterSpacing="0.12em"
      textTransform="uppercase"
      borderRadius="2px"
      borderColor={active ? 'accent.500' : 'line.subtle'}
      color={active ? 'accent.500' : 'text.muted'}
      _hover={{
        borderColor: active ? 'accent.500' : 'text.muted',
        color: active ? 'accent.500' : 'text.primary',
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
